const mql = window.matchMedia('only screen and (max-width: 768px)');

window.Currency = (function () {

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();


class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.select = this.querySelector('select');
    if (this.select) { 
      this.select.addEventListener('change', this.onSelectChange.bind(this));
    }
    if (this.input) {
      this.maxValue = this.input.max;
      this.minValue = this.input.min;
      this.disableButtons();
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
    
      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }
    this.changeEvent = new Event('change', { bubbles: true })
    
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );


  }

  onChange(event) {
    this.disableButtons();
  }

  onSelectChange() {
    const selectValue = this.select.options[this.select.selectedIndex].value;
    this.input.value = selectValue;
  }

  

  disableButtons(event) {

    this.currentValue = this.input.value;

    if (this.maxValue == this.currentValue) {
      this.querySelector('[name="plus"]').disabled = true;
    } else {
      this.querySelector('[name="plus"]').disabled = false;
    }

    if (this.minValue == this.currentValue) {
      this.querySelector('[name="minus"]').disabled = true;
    } else {
      this.querySelector('[name="minus"]').disabled = false;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) { 
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
    if (this.dataset.sticky) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          const isAboveViewport = !entry.isIntersecting && entry.boundingClientRect.y < 0;
          entry.target.classList.toggle('is-sticky', isAboveViewport);

          if (isAboveViewport) {
            setTimeout(() => {
              entry.target.classList.add('is-visible');
            }, 10);
          } else {
            entry.target.classList.remove('is-visible');
          }
        },
        { threshold: [0] }
      );
      observer.observe(this);
    }
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.button-show-more)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('*'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add('menu-is-open');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      document.body.classList.remove('menu-is-open');

      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}


customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.setVar('loadPage')
  }

  setVar(when) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    this.usps = this.header.querySelector('.usp-bar');
    if (this.usps) {
      this.uspOffset = this.usps.offsetHeight;
    } else {
      this.uspOffset = 0;
    }
    var headerPosition = '0';
    if (when == 'loadPage') {
      headerPosition = this.header.offsetHeight + this.uspOffset; 
    } else {
      headerPosition = this.header.getBoundingClientRect().bottom;
    }
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(headerPosition - this.borderOffset - this.uspOffset)}px`);
    document.documentElement.style.setProperty('--header-height', `${parseInt(this.header.offsetHeight)}px`);


  }

  openMenuDrawer(summaryElement) {
    this.setVar('openMenu');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.buttonList = this.querySelectorAll('button:not([id^="ModalClose-"]):not([data-media-id]):not(.disclosure__button)');
    this.buttonList.forEach(button => {
      button.addEventListener('click', this.hide.bind(this));
    });

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model, modal-thumbnails')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
        if (event.target.nodeName === 'QUICK-VIEW-MODAL') this.hide();
        if (event.target.nodeName === 'MODAL-POPUP') this.hide();
        if (event.target.nodeName === 'QUICK-ADD-MODAL') this.hide();

      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class ModalHover extends ModalOpener {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;

    button.addEventListener('mouseenter', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-hover', ModalHover);


class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
      if (this.querySelector('video')) {
        if (this.querySelector('video').hasAttribute('autoplay')) {
          this.querySelector('video').play();
        }
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.sliderId = this.querySelectorAll('[id^="Slider-"]')[0].id.split('-')[1];
    this.slider = this.querySelector(`[id^="Slider-${this.sliderId}"]`);
    this.sliderItems = this.querySelectorAll(`[id^="Slide-${this.sliderId}"]`);
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector(`[id^="Buttons-${this.sliderId}"] button[name="previous"]`) || this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector(`[id^="Buttons-${this.sliderId}"] button[name="next"]`) || this.querySelector('button[name="next"]');


    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll(`[id^="Slide-${this.sliderId}"]`);
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }
      }));
      this.dispatchEvent(new CustomEvent('sliderUsed', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
    this.dispatchEvent(new CustomEvent('sliderUsed', { detail: {
      currentPage: this.currentPage,
      currentElement: this.sliderItemsToShow[this.currentPage - 1]
    }}));
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();

    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }


  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    console.log(this.sliderControlLinksArray.indexOf(event.currentTarget));
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
    console.log(this.currentPage);
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.detailsList = this.querySelectorAll('details');
    this.optionList = this.querySelectorAll('label');
    this.optionList.forEach((option) => {
      option.addEventListener('click', this.onOptionClick.bind(this));
    });
    // check if the element is inside a quick-add-modal
    if (this.closest('quick-add-modal')) {
      this.isQuickAddModal = true;
    }
  }

  onVariantChange(event) {
    console.log(event);
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateStickyButton();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      if (!this.isQuickAddModal) this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  onOptionClick(event) {
    this.fieldset = event.target.closest('fieldset');
    this.details = this.fieldset.querySelector('details');

    if (this.details) { 
      this.details.open = false;
      this.details.querySelector('.form__label span').innerHTML = event.target.dataset.label;
    }
    if (event.type !== 'change') {
      
      this.onVariantChange(event);
    
    }

  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );


      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  updateStickyButton() {
    this.stickyButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('sticky-button');
    if (!this.stickyButton) return;

    // Don't change the action - keep it as 'choose-variant' if that's what it was
    // The button will handle clicking submit when a variant is selected
    const originalAction = this.stickyButton.getAttribute('data-original-action');
    if (originalAction === 'choose-variant') {
      this.stickyButton.dataset.action = 'choose-variant';
    } else if (this.currentVariant) {
      this.stickyButton.dataset.action = 'add';
    } else {
      this.stickyButton.dataset.action = 'scroll';
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class CartAddButton extends HTMLElement {
  constructor() {
    super();
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    if(this.cartNotification){
      this.cart = this.cartNotification;
    } else {
      this.cart = this.cartDrawer;
    }
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.addProduct(this.dataset.id, 1);
      } else {
        this.addProduct(this.dataset.id, 1);
      }
    });
  }
  addProduct(id, quantity) {
    this.setAttribute('aria-disabled', true);
    this.classList.add('loading');
    //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    const body = JSON.stringify({
      id,
      quantity,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }

      this.cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.classList.remove('loading');
      this.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
  }
}
customElements.define('cart-add-button', CartAddButton);




class CartShippingCosts extends HTMLElement {
  constructor() {
    super();
    this.calculateShippingCosts();
  }

  init() {
    this.shippingCostElem = this.querySelector('[data-shipping-costs]');
    this.totalPriceElem = this.querySelector('[data-price]');
    this.originalPrice = parseInt(this.totalPriceElem.dataset.price);
    this.goodieNotification = document.querySelector('.cart-drawer__goodie-text');
  }

  calculateShippingCosts() {
    fetch(`${routes.cart_url}/prepare_shipping_rates.json?shipping_address%5Bzip%5D=${window.shipping.postal_code}&shipping_address%5Bcountry%5D=${window.shipping.country}`, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(),
    })
      .then(response => response.json())
      .then(data => {
         return fetch(
          `${routes.cart_url}/async_shipping_rates.json?shipping_address%5Bzip%5D=${window.shipping.postal_code}&shipping_address%5Bcountry%5D=${window.shipping.country}`,
          {
            method: 'GET',
            body: JSON.stringify()
          }
        );
      })
      .then(response => response.json())
      .then(rates => {
        this.init();
        const firstShippingRate = rates.shipping_rates[0];
        if (!firstShippingRate) {
          this.querySelector('#shipping-costs').classList.add('hidden');
        } else {

          const newTotalPrice = (firstShippingRate.price * 100) + this.originalPrice;
          this.shippingCostElem.innerHTML = window.Currency.formatMoney(firstShippingRate.price, window.currency.currencyFormat);
          this.totalPriceElem.innerHTML = window.Currency.formatMoney(newTotalPrice, window.currency.currencyFormat);  
        }
      });
  }
}

customElements.define('cart-shipping-costs', CartShippingCosts);


class FaqSection extends HTMLElement {
  constructor() {
    super();

    this.categories = this.querySelectorAll('.faq-content-titles button');
    this.sections = Array.from(this.querySelectorAll('.faq-content-content .faq-category'));
    this.detailList = this.querySelectorAll('details');

    this.categories.forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.detailList.forEach(
      (detail) => detail.addEventListener('toggle', this.onDetailToggle.bind(this))
    );

    this.openActiveElement();

  }

  onDetailToggle(event) {
    this.activeElement = event.target.dataset.link;
    window.history.replaceState({ }, '', `${this.dataset.url}#${this.activeElement}`);

  }

  openActiveElement(event) {
    const hash = window.location.hash;
    if (hash) {
      const detail = this.querySelector(`details[data-link="${hash.substring(1)}"]`);
      if (detail) {
        const closestSection = detail.closest('section');
        const blockToExpand = closestSection.dataset.expand;
        this.openSection(blockToExpand);
        detail.open = true;
      }
    }
  }

  openSection(blockToExpand) {
    this.categories.forEach((button) => {
      if (button.dataset.expand !== blockToExpand) {
        button.classList.remove('is-active');
      } else {
        button.classList.add('is-active');
      }
    });
    const section = this.sections.find((section) => section.dataset.expand === blockToExpand);
    if (section) {
      section.classList.add('is-active');
      this.sections.forEach((section) => {
        if (section.dataset.expand !== blockToExpand) {
          section.classList.remove('is-active');
        }
      });
    }
    
  }

  onButtonClick(event) {
    const dataExpand = event.target.dataset.expand;
    const blockToExpand = event.target.dataset.expand;
    this.openSection(blockToExpand);

    
  }

}

customElements.define('faq-section', FaqSection);

class ModalPopup extends ModalDialog {
  constructor() {
    super();

    this.timeOut = this.dataset.start;
    this.testMode = this.dataset.test;
    this.cookieName = this.dataset.cookie;

    if (this.testMode) {
      this.show();
    }

    if(localStorage.getItem(this.cookieName) === 'true') return;

    this.init.bind(this)();
    
  }

  init() {
    setTimeout(function(){ this.show() }.bind(this), this.timeOut);
  }

  show() {
    super.show();
    localStorage.setItem(this.cookieName, true);
  }
}
customElements.define('modal-popup', ModalPopup);

class FooterBlock extends HTMLElement {
  constructor(){
    super();
    this.summary = this.querySelector('summary');
    this.details = this.querySelector('details');
    if (!this.summary) return;
    this.init();

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));

    
    
    mql.addEventListener('change', this.init.bind(this));
    
  }
  
  init() {
    if (mql.matches) {
      this.details.open = false;
    } else {
      this.details.open = true;
    }
  }

  onSummaryClick(event) {
    if (!mql.matches) {
      event.preventDefault();
    }
  }

}

customElements.define('footer-block', FooterBlock);



class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    if (this.elements.button) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    }
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    if (!this.closest('.shopify-section')) return;
    this.closest('.shopify-section').classList.add('locale-selector--open');
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
      if (!this.closest('.shopify-section')) return;
      this.closest('.shopify-section').classList.remove('locale-selector--open');
    }
  }
}

customElements.define('localization-form', LocalizationForm);

function setVw() {
  let vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}

setVw();
window.addEventListener('resize', setVw);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



class MediaScroller extends HTMLElement {
  constructor() {
    super();
    this.contentLoaded = false; // Flag to track content loading
    this.slider = this.querySelector('slideshow-component');
    this.slider.addEventListener('sliderUsed', debounce(this.onSlideChanged.bind(this), 500));
    
    // Hover state tracking
    this.isHovering = false;
    this.hoveredFromFirstPage = false;
    this.hoverRetryCount = 0;

    // // Use IntersectionObserver if available in the browser
    // if ('IntersectionObserver' in window) {
    //   this.createIntersectionObserver();
    // } else {
    //   // Fallback or consider a polyfill
    //   console.log('IntersectionObserver is not supported by this browser.');
    // }
  }

  onSlideChanged(event) {
    // this.addEmptySlide();
    // this.renderProductGallery();



    this.renderProductGallery();

  }

  addEmptySlide() {
    const galleryDiv = this.querySelector('div[data-gallery="true"] .slider');
    if (galleryDiv) {
      const emptySlide = document.createElement('li');
      // Assigning an ID based on the current number of slides + 1
      emptySlide.id = `Slide-${this.dataset.id}-${galleryDiv.children.length + 1}`;
      galleryDiv.appendChild(emptySlide);
    }
  }


  connectedCallback() {
    // Optionally, you could keep your mouseenter event for non-touch devices
    // this.addEventListener('mouseenter', this.renderProductGallery);
    
    // Add hover event listeners
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }
  
  onMouseEnter() {
    if (!this.slider || !this.slider.slider) return;
    
    this.isHovering = true;
    
    // Wait for slider to be initialized (max 3 retries)
    if ((!this.slider.sliderItemOffset || !this.slider.sliderItemsToShow) && this.hoverRetryCount < 3) {
      this.hoverRetryCount++;
      setTimeout(() => this.onMouseEnter(), 50);
      return;
    }
    
    this.hoverRetryCount = 0;
    
    // Check if we're on the first page
    const currentPage = this.slider.currentPage || 1;
    if (currentPage === 1) {
      this.hoveredFromFirstPage = true;
      
      // Scroll to second page
      if (this.slider.sliderItemsToShow.length > 1) {
        const secondPageScrollPosition = this.slider.sliderItemOffset;
        this.slider.slider.scrollTo({
          left: secondPageScrollPosition,
          behavior: 'smooth'
        });
      }
    } else {
      this.hoveredFromFirstPage = false;
    }
  }
  
  onMouseLeave() {
    this.isHovering = false;
    
    // Always reset to first image if we hovered from the first page
    if (this.hoveredFromFirstPage && this.slider && this.slider.slider) {
      this.slider.slider.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    }
    
    this.hoveredFromFirstPage = false;
  }

  createIntersectionObserver() {
    const options = {
      root: null, // observing intersections relative to the viewport
      threshold: 0.1, // trigger when at least 10% of the element is visible
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.contentLoaded) {
          this.renderProductGallery();
          observer.unobserve(this); // Stop observing after loading content
        }
      });
    }, options);

    observer.observe(this); // Start observing this element
  }

  renderProductGallery = () => {
    if (this.contentLoaded) {
      return;
    }
    const fetchUrl = `${this.dataset.url}?section_id=${this.dataset.section}`;

    fetch(fetchUrl)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const source = html.querySelector('.shopify-section');
        this.appendFetchedContent(source.innerHTML);
        this.contentLoaded = true; // Set the flag to true after content is added;
        this.slider.resetPages();
      })
      .catch(error => {
        console.error('There has been a problem with your fetch operation:', error);
      });
  }

  appendFetchedContent = (content) => {
    const galleryDiv = this.querySelector('div[data-gallery="true"] .slider');
    if (galleryDiv) {

      // Remove the placeholder empty li element
      const placeholderSlide = galleryDiv.querySelector('li:last-child');
      if (placeholderSlide) {
        galleryDiv.removeChild(placeholderSlide);
      }
      // Insert the content at the end of the gallery div
    galleryDiv.insertAdjacentHTML("beforeend", content);

    // Fetch all child elements that were just appended
    const newElements = Array.from(galleryDiv.children).slice(-new DOMParser().parseFromString(content, 'text/html').body.childNodes.length);

    newElements.forEach((elem) => {
      if (elem.dataset.index) {
        // Use the data-index for the ID, assuming data-index is already defined in your content
        elem.id = `Slide-${this.dataset.id}-${elem.dataset.index}`;
      }
    });

    } else {
      console.log("No gallery div found within this media-scroller element.");
    }
  }
}

customElements.define('media-scroller', MediaScroller);

class ShippingTimer extends HTMLElement {
  constructor() {
    super();
    this.timerElement = null;
    this.timerIntervalId = null;
  }

  connectedCallback() {
    this.targetTime = this.getAttribute('data-time');
    this.timerElement = this.querySelector('[data-timer]');
    this.calculateTargetDate();
    this.startTimer();
  }

  disconnectedCallback() {
    if (this.timerIntervalId) {
      clearInterval(this.timerIntervalId);
      this.timerIntervalId = null;
    }
  }

  calculateTargetDate() {
    const now = new Date();
    const [hours, minutes, seconds] = this.targetTime.split(':').map(Number);
    this.targetDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, seconds);

    if (now > this.targetDate) {
      this.style.display = 'none';
    }
  }

  startTimer() {
    if (this.style.display !== 'none') {
      this.updateTimer();
      this.timerIntervalId = setInterval(() => this.updateTimer(), 1000);
    }
  }

  updateTimer() {
    const timeDifference = this.getTimeDifference();

    if (timeDifference.total <= 0) {
      if (this.timerElement) {
        this.timerElement.innerHTML = "00:00:00";
      }
      if (this.timerIntervalId) {
        clearInterval(this.timerIntervalId);
        this.timerIntervalId = null;
      }
    } else {
      const hours = timeDifference.hours.toString().padStart(2, '0');
      const minutes = timeDifference.minutes.toString().padStart(2, '0');
      const seconds = timeDifference.seconds.toString().padStart(2, '0');
      if (this.timerElement) {
        this.timerElement.innerHTML = `${hours}:${minutes}:${seconds}`;
      }
    }
  }

  getTimeDifference() {
    const now = new Date();
    const total = this.targetDate - now;
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    return { total, hours, minutes, seconds };
  }
}

customElements.define('shipping-timer', ShippingTimer);


class CartLink extends HTMLElement {
  constructor() {
    super();
    this.message = this.querySelector('.buy-buttons__success-message');
    this.cartNotification = document.querySelector('cart-drawer');
    if (this.cartNotification) {
       
      this.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.cartNotification.header) this.cartNotification.header.reveal();
        this.cartNotification.open();
      });
    }
  }

  refreshCart() {
    fetch(`${routes.cart_url}.js`)
      .then(response => response.json())
      .then(cart => {
        this.querySelector('.cart-count-bubble span').textContent = cart.item_count;
      });
  }

  showMessage() {
    this.message.classList.add('active');
    setTimeout(() => {
      this.message.classList.remove('active');
    }, 6000);
  }

}

customElements.define('cart-link', CartLink);

class QuickViewModal extends ModalDialog {
  constructor() {
    super();

    this.handle = this.dataset.handle;
    this.modalContent = this.querySelector('[id^="QuickViewInfo-"]');

  }

  connectedCallback() {

  }

  hide(preventFocus = false) {
    const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartNotification) cartNotification.setActiveElement(this.openedBy);
    this.modalContent.innerHTML = '';

    if (preventFocus) this.openedBy = null;
    super.hide();
  }

  show(opener) {
    opener.setAttribute('aria-disabled', true);
    opener.classList.add('loading');
    opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    fetch(opener.getAttribute('data-product-url'))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.setInnerHTML(this.modalContent, responseHTML.querySelector('.shopify-section').innerHTML);


        this.preventVariantURLSwitching();
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        
      })
      .finally(() => {
        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading');
        opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;
  }

  preventVariantURLSwitching() {
    const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
    if (!variantPicker) return;

    variantPicker.setAttribute('data-update-url', 'false');
  }








}

customElements.define('quick-view-modal', QuickViewModal);

class StickyVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.mainVariantSelects = null;
  }

  connectedCallback() {
    const mainVariantSelectsId = this.dataset.mainVariantSelects;
    if (mainVariantSelectsId) {
      this.mainVariantSelects = document.getElementById(mainVariantSelectsId);
    }
    
    if (!this.mainVariantSelects) return;

    this.render();
    this.attachEventListeners();
    this.syncVisualState();
    
    // Listen to changes in the main variant-selects to sync visual state
    this.mainVariantSelects.addEventListener('change', () => {
      this.syncVisualState();
    });
  }

  render() {
    if (!this.mainVariantSelects) return;

    const fieldsets = this.mainVariantSelects.querySelectorAll('fieldset:not(.hidden)');
    if (fieldsets.length === 0) return;

    // Get the template fieldset structure (it should be in the cloned element)
    const templateFieldset = this.querySelector('.sticky-variant-selects__fieldset');
    if (!templateFieldset) return;

    // Get template option wrapper before clearing
    const templateOptionWrapper = templateFieldset.querySelector('.sticky-variant-selects__option-wrapper');
    if (!templateOptionWrapper) return;

    // Clear existing fieldsets (keep close button)
    const closeButton = this.querySelector('.sticky-variant-selects__close');
    const fieldsetsToRemove = this.querySelectorAll('.sticky-variant-selects__fieldset');
    fieldsetsToRemove.forEach(fs => fs.remove());

    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend');
      if (!legend) return;

      const optionName = legend.textContent.trim().replace(':', '');
      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      
      if (inputs.length === 0) return;

      // Clone the template fieldset
      const stickyFieldset = templateFieldset.cloneNode(true);
      
      // Set label text
      const label = stickyFieldset.querySelector('.sticky-variant-selects__label');
      if (label) {
        label.textContent = optionName;
      }

      // Get options container and clear the template option
      const optionsContainer = stickyFieldset.querySelector('.sticky-variant-selects__options');
      if (!optionsContainer) return;
      optionsContainer.innerHTML = '';

      inputs.forEach((input) => {
        const originalLabel = fieldset.querySelector(`label[for="${input.id}"]`);
        if (!originalLabel) return;

        const isDisabled = input.classList.contains('disabled');
        const isChecked = input.checked;

        // Clone template option wrapper
        const optionWrapper = templateOptionWrapper.cloneNode(true);
        
        // Get and configure radio input
        const radioInput = optionWrapper.querySelector('input[type="radio"]');
        if (radioInput) {
          radioInput.id = `sticky-${input.id}`;
          radioInput.name = `sticky-${input.name}`;
          radioInput.value = input.value;
          radioInput.dataset.mainInputId = input.id;
          radioInput.checked = isChecked;
          radioInput.disabled = isDisabled;
          if (isDisabled) {
            radioInput.classList.add('disabled');
          }
        }

        // Get and configure label
        const labelElement = optionWrapper.querySelector('label');
        if (labelElement) {
          labelElement.htmlFor = radioInput.id;
          
          // Set option text
          const optionText = labelElement.querySelector('.sticky-variant-selects__option-text');
          if (optionText) {
            optionText.textContent = input.value;
          }
          
          // Handle sold out text
          const soldOutText = labelElement.querySelector('.sticky-variant-selects__sold-out');
          if (soldOutText) {
            if (isDisabled) {
              soldOutText.textContent = window.variantStrings?.soldOut || 'Sold out';
              soldOutText.classList.remove('hidden');
            } else {
              soldOutText.classList.add('hidden');
            }
          }

          if (isChecked) {
            labelElement.classList.add('selected');
          }
        }

        optionsContainer.appendChild(optionWrapper);
      });

      this.appendChild(stickyFieldset);
    });
  }

  attachEventListeners() {
    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', (event) => {
        this.handleOptionChange(event);
      });
    });

    // Add close button listener
    const closeButton = this.querySelector('.sticky-variant-selects__close');
    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        event.stopPropagation(); // Prevent triggering click-outside handler
        this.handleClose();
      });
    }
  }

  handleClose() {
    // Find the sticky-button parent and hide the variant selects
    const stickyButton = this.closest('sticky-button');
    if (stickyButton && stickyButton.hideVariantSelects) {
      stickyButton.hideVariantSelects();
    }
  }

  handleOptionChange(event) {
    const radio = event.currentTarget;
    if (radio.disabled || radio.classList.contains('disabled')) return;

    const mainInputId = radio.dataset.mainInputId;
    const mainInput = this.mainVariantSelects.querySelector(`#${mainInputId}`);
    
    if (!mainInput) return;

    // Update the main input
    mainInput.checked = true;
    
    // Dispatch change event to trigger VariantSelects.onVariantChange
    const changeEvent = new Event('change', { bubbles: true });
    mainInput.dispatchEvent(changeEvent);

    // Update visual state
    this.syncVisualState();
  }

  syncVisualState() {
    if (!this.mainVariantSelects) return;

    // Update selected and disabled state
    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      const mainInputId = radio.dataset.mainInputId;
      const mainInput = this.mainVariantSelects.querySelector(`#${mainInputId}`);
      
      if (mainInput) {
        const label = this.querySelector(`label[for="${radio.id}"]`);
        
        // Update checked state
        radio.checked = mainInput.checked;
        if (mainInput.checked && label) {
          label.classList.add('selected');
        } else if (label) {
          label.classList.remove('selected');
        }

        // Update disabled state
        const isDisabled = mainInput.classList.contains('disabled');
        radio.disabled = isDisabled;
        if (isDisabled) {
          radio.classList.add('disabled');
        } else {
          radio.classList.remove('disabled');
        }
      }
    });
  }
}

customElements.define('sticky-variant-selects', StickyVariantSelects);

if (!customElements.get('sticky-button')) {
  customElements.define('sticky-button', class StickyButton extends HTMLElement {
    constructor() {
      super();
  
      this.action = this.dataset.action;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.options = document.getElementById(`variant-selects-${this.dataset.section}`);
    }

    connectedCallback() {
      this.productFormButton = this.form.closest('product-form');

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.isVariantSelectsVisible = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.form = document.querySelector('product-form');
    


      this.createObserver();

      // Handle choose-variant action
      if (this.dataset.action === 'choose-variant') {
        this.initVariantSelects();
      }

      // Use event delegation on the sticky-button element itself
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (button && this.contains(button)) {
          event.preventDefault();
          event.stopPropagation();
          this.handleClick(event);
        }
      });
    }

    initVariantSelects() {
      const section = this.closest('.shopify-section');
      if (!section) return;

      const mainVariantSelects = section.querySelector('variant-selects');
      if (!mainVariantSelects) return;

      // Store original action if not already stored
      if (!this.hasAttribute('data-original-action')) {
        this.setAttribute('data-original-action', this.dataset.action);
      }

      // Check if sticky-variant-selects already exists
      if (this.querySelector('sticky-variant-selects')) return;

      // Get template and clone it
      const template = this.querySelector(`#sticky-variant-selects-template-${this.dataset.section}`);
      if (!template) return;

      const stickyVariantSelects = template.content.cloneNode(true).querySelector('sticky-variant-selects');
      stickyVariantSelects.dataset.mainVariantSelects = mainVariantSelects.id;
      stickyVariantSelects.classList.add('hidden');

      // Insert inside the div (button wrapper)
      const buttonWrapper = this.querySelector('div');
      if (buttonWrapper) {
        buttonWrapper.insertBefore(stickyVariantSelects, buttonWrapper.querySelector('button'));
      } else {
        this.appendChild(stickyVariantSelects);
      }

      // Store reference
      this.stickyVariantSelects = stickyVariantSelects;

      // Add click-outside handler
      this.setupClickOutsideHandler();
    }

    setupClickOutsideHandler() {
      this.clickOutsideHandler = (event) => {
        if (!this.stickyVariantSelects || !this.isVariantSelectsVisible) return;
        
        // Check if click is outside sticky-button
        // Also check if it's not the button that opens the variant selects
        const button = this.querySelector('button');
        if (!this.contains(event.target) && event.target !== button) {
          this.hideVariantSelects();
        }
      };

      // Use capture phase to catch clicks before they bubble
      document.addEventListener('click', this.clickOutsideHandler, true);
    }

    showVariantSelects() {
      if (this.stickyVariantSelects) {
        this.stickyVariantSelects.classList.remove('hidden');
        this.isVariantSelectsVisible = true;
      }
    }

    hideVariantSelects() {
      if (this.stickyVariantSelects) {
        this.stickyVariantSelects.classList.add('hidden');
        this.isVariantSelectsVisible = false;
      }
    }


    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // Remove click-outside handler
      if (this.clickOutsideHandler) {
        document.removeEventListener('click', this.clickOutsideHandler, true);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.productFormButton);
    }

    isInViewport(elements) {
      return elements.some(elem => {
        if (elem) {
          var bounding = elem.getBoundingClientRect();
          return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
        }
        return false;
      });
    }


    onScroll() {
      // Modification to use an array of elements for viewport visibility check
      const elementsToCheck = [this.productFormButton, this.options].filter(Boolean); // Filter out any undefined/null elements
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
      if (!this.preventReveal) {
        if (this.isInViewport(elementsToCheck)) {
          requestAnimationFrame(this.hideForm.bind(this));
        } else {
          requestAnimationFrame(this.revealForm.bind(this));
        }
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
      }
    
      return false;
    }

    hideForm() {
      this.classList.remove('sticky-form-sticky');

    }

    revealForm() {
      this.classList.add('sticky-form-sticky');
    }

    reset() {
      this.classList.remove('sticky-form-sticky');
    }

    handleClick(event) {
      // Prevent the default button action
      event.preventDefault();
      event.stopPropagation(); // Stop event from bubbling to click-outside handler

      // Check the current action from dataset
      const currentAction = this.dataset.action;

      if (currentAction === 'choose-variant') {
        // If variant selects is visible, check if variant is selected and add to cart
        if (this.isVariantSelectsVisible) {
          const section = this.closest('.shopify-section');
          if (section) {
            const variantSelects = section.querySelector('variant-selects');
            if (variantSelects) {
              variantSelects.updateOptions();
              variantSelects.updateMasterId();
              if (variantSelects.currentVariant && this.form) {
                this.form.querySelector('button[type="submit"]').click();
                return;
              }
            }
          }
        } else {
          // Show variant selects
          this.showVariantSelects();
        }
      } else if (currentAction === 'scroll' && this.options) {
        this.options.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstFieldset = this.options.querySelector('fieldset:not(.hidden)');
        if (firstFieldset) {
          const details = firstFieldset.querySelector('details');
          if (details) details.open = true;
        }
      } else if (currentAction === 'add' && this.form) {
        this.form.querySelector('button[type="submit"]').click(); // More specific selector for form submission
      }
    }
  });
}